// extracted by mini-css-extract-plugin
export default {"layoutContainer":"restricted-access_layoutContainer__63uW9"};